import { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import { useBlog } from '../contexts/BlogContext'

function BlogPost() {
  const { id } = useParams()
  const [post, setPost] = useState(null)
  const [error, setError] = useState(null)
  const { fetchSinglePost, loading, getCategoriesList } = useBlog()
  const [categories, setCategories] = useState([])

  useEffect(() => {
    const loadPost = async () => {
      try {
        const data = await fetchSinglePost(id)
        console.log('Post data:', data) // Debug log
        setPost(data)
        // Load categories for sidebar
        const cats = await getCategoriesList()
        setCategories(cats)
      } catch (err) {
        console.error('Error loading post:', err)
        setError('Error al cargar el artículo. Por favor, intente más tarde.')
      }
    }

    loadPost()
  }, [id, fetchSinglePost, getCategoriesList])

  if (loading) {
    return (
      <>
        <Header />
        <main id="main">
          <section id="breadcrumbs" className="breadcrumbs">
            <div className="container">
              <div className="text-center py-5">
                <p>Cargando artículo...</p>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </>
    )
  }

  if (error) {
    return (
      <>
        <Header />
        <main id="main">
          <section id="breadcrumbs" className="breadcrumbs">
            <div className="container">
              <div className="text-center py-5">
                <p className="text-danger">{error}</p>
                <Link to="/blog" className="btn btn-primary mt-3">Volver al Blog</Link>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </>
    )
  }

  if (!post) {
    return (
      <>
        <Header />
        <main id="main">
          <section id="breadcrumbs" className="breadcrumbs">
            <div className="container">
              <div className="text-center py-5">
                <h2>Artículo no encontrado</h2>
                <Link to="/blog" className="btn btn-primary mt-3">Volver al Blog</Link>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </>
    )
  }

  return (
    <>
      <Header />

      <main id="main">
        {/* ======= Breadcrumbs ======= */}
        <section id="breadcrumbs" className="breadcrumbs">
          <div className="container">
            <ol>
              <li><Link to="/">Inicio</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li>{post.title}</li>
            </ol>

            {/* Blog Post Content */}
            <div className="row blog-content" style={{ marginTop: '40px' }}
              onContextMenu={(e) => e.preventDefault()}
              onCopy={(e) => e.preventDefault()}
              onCut={(e) => e.preventDefault()}
            >
              <div className="col-lg-8" style={{ userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none' }}>
                <article className="entry entry-single">
                  <div className="entry-meta">
                    <ul>
                      <li className="d-flex align-items-center">
                        <i className="bi bi-person"></i>
                        <span>{post.author}</span>
                      </li>
                      <li className="d-flex align-items-center">
                        <i className="bi bi-clock"></i>
                        <time dateTime={post.date}>
                          {new Date(post.date).toLocaleDateString('es-ES', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                          })}
                        </time>
                      </li>
                      <li className="d-flex align-items-center">
                        <i className="bi bi-folder"></i>
                        <span>{post.category}</span>
                      </li>
                    </ul>
                  </div>

                  <h1 className="entry-title">{post.title}</h1>

                  <div className="entry-content" dangerouslySetInnerHTML={{ __html: post.content }}>
                  </div>

                  <div className="entry-footer">
                    <div className="d-flex justify-content-between">
                      <Link to="/blog" className="btn btn-outline-primary">
                        <i className="bi bi-arrow-left"></i> Volver al Blog
                      </Link>
                      <a href="https://wa.me/+5491124089830?text=Hola%20necesito%20asesoramiento"
                        className="btn btn-primary">
                        Consulta sin cargo
                      </a>
                    </div>
                  </div>
                </article>
              </div>

              {/* Sidebar */}
              <div className="col-lg-4">
                <div className="sidebar">

                  {/* Contact CTA */}
                  <div className="sidebar-item">
                    <h3 className="sidebar-title">¿Necesitas asesoramiento?</h3>
                    <div className="text-center">
                      <p>Consulta sin cargo sobre tu caso</p>
                      <a href="https://wa.me/+5491124089830?text=Hola%20necesito%20asesoramiento"
                        className="btn btn-success">
                        <i className="bi bi-whatsapp"></i> Contactar
                      </a>
                    </div>
                  </div>

                  {/* Categories */}
                  <h3 className="sidebar-title">Categorías</h3>
                  <div className="sidebar-item categories">
                    <ul>
                      {categories.map(category => (
                        <li key={category.id}>
                          <Link to={`/blog?category=${category.id}`}>
                            {category.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  )
}

export default BlogPost